// extracted by mini-css-extract-plugin
module.exports =  {"seller-level-tooltip":"_ccCr7p","sellerLevelTooltip":"_ccCr7p","seller-level":"Q7hxmh4","sellerLevel":"Q7hxmh4","top-rated":"Vj3skcN","topRated":"Vj3skcN"};